"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = exports["default"] = {
  framerate: 24,
  images: [require('./cornerSprite.png')],
  frames: [[297, 292, 291, 286, 0, 71, 2], [297, 582, 291, 286, 0, 71, 2], [2, 582, 291, 286, 0, 71, 2], [1477, 292, 291, 286, 0, 71, 2], [1182, 292, 291, 286, 0, 71, 2], [887, 292, 291, 286, 0, 71, 2], [592, 292, 291, 286, 0, 71, 2], [592, 582, 291, 286, 0, 71, 2], [2, 292, 291, 286, 0, 71, 2], [1477, 2, 291, 286, 0, 71, 2], [1182, 2, 291, 286, 0, 71, 2], [887, 2, 291, 286, 0, 71, 2], [592, 2, 291, 286, 0, 71, 2], [297, 2, 291, 286, 0, 71, 2], [2, 2, 291, 286, 0, 71, 2]],
  animations: {
    still: {
      frames: [0, 0, 0],
      speed: 1
    },
    'speech loop': {
      frames: [1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 6, 7, 8, 9, 10, 10, 3, 3, 3, 11, 11, 11, 12, 12, 12, 2, 2, 2, 13, 13, 13, 14, 14, 14, 4, 4, 4, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4, 11, 11, 11, 12, 12, 10, 10, 10, 3, 3, 3],
      speed: 1
    }
  }
};